import { useState, useEffect } from 'react'
import { useResponseHandler } from '../../../../common/auth';
import { NoDataContent, Checkbox, DropDownSelector } from '@lk-gtcom/ecomlab-components';
import { useParams } from 'react-router-dom';
import useGeneralStore from '../../../../store/general';
import customHeaders, { getSpace } from '../../../../common/headers';
import { ExecutorPlaceholder } from '../../../OptionsExecutor/OptionsExecutor';
import RoleBadje from '../../../RoleBadge/RoleBadje';
import { ModalComponent } from '../../ModalComponent/ModalComponent';
import './ModalAddPermission.scss'

const options_prop = [
    { label: 'Читатель', value: 'viewer' },
    { label: 'Соавтор', value: 'collaborator' }
];

const ModalAddPermission = ({
    setIsModal,
    selectedDirectory,
    setSelectedDirectory,
    onSuccess = () => { }
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const author_client_id = localStorage.getItem('client_id');

    const fileName = useParams()['*']?.split('/')
    const currentDirectory = fileName?.at(-1)

    const [listUsers, setListUsers] = useState([])
    const [selectedExecutor, setSelectedExecutor] = useState([])
    const [userRoles, setUserRoles] = useState({})

    // Список юзеров и прав для них
    const fetchGetPermissionList = () => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/directory/${selectedDirectory}/participants`;

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                if (Array.isArray(json)) {
                    setListUsers(json)
                    const rolesMap = {};
                    json.forEach(user => {
                        rolesMap[user.id] = user.role_directory;
                    });
                    setUserRoles(rolesMap);
                }
                const check_list = json
                    ?.filter((user) => user?.role_directory === 'collaborator')
                    ?.map((user) => user?.id)
                setSelectedExecutor(check_list)
            })
            .catch(handleRequestError);
    };

    // Добавить права
    const fetchAddPermission = (client_id, permission) => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/directory/permission`;

        const body = JSON.stringify({
            directory_id: selectedDirectory,
            client_id: client_id,
            role: permission
        })

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then((json) => {
                fetchGetPermissionList()
                if (author_client_id == client_id) {
                    onSuccess()
                }
            })
            .catch(handleRequestError);
    };

    // Удалить права
    const fetchDeletePermission = (client_id) => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/directory/permission`;

        const body = JSON.stringify({
            directory_id: selectedDirectory,
            client_id: client_id
        })

        fetch(url, { method: 'DELETE', headers, body })
            .then(handleTableResponse)
            .then((json) => {
                fetchGetPermissionList()
                if (author_client_id == client_id) {
                    onSuccess()
                }
            })
            .catch(handleRequestError);
    };

    const handleRoleChange = (client_id, newRole, currentRole) => {
        if (currentRole === 'owner') return; // Нельзя изменить права владельца
        setUserRoles(prev => ({
            ...prev,
            [client_id]: newRole
        }));
        fetchAddPermission(client_id, newRole);
    };

    useEffect(() => {
        if (selectedDirectory) {
            fetchGetPermissionList()
        }
    }, [selectedDirectory]);

    return (
        <ModalComponent
            title='Добавить права'
            onClose={(e) => {
                setSelectedDirectory(null)
                setIsModal(false);
            }}
            style={{
                maxWidth: '800px'
            }}
            child={
                <div className="modal-add-permission">
                    {listUsers?.length ?
                        <div className="modal-add-permission__list-executor">
                            {listUsers?.map(
                                ({ id, name, login, color, role, role_directory, role_name }) => (
                                    <div
                                        className={'modal-add-permission__executor-item'}
                                        key={id + role_directory}
                                    >
                                        <Checkbox
                                            value={role_directory}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setSelectedExecutor((prev) =>
                                                    prev?.includes(id)
                                                        ? prev?.filter((el) => el !== id)
                                                        : [...prev, id]
                                                );
                                                if (role_directory) {
                                                    fetchDeletePermission(id)
                                                } else {
                                                    fetchAddPermission(id, 'viewer')
                                                }
                                            }}
                                            disabled={role_directory === 'owner'}
                                        />

                                        <ExecutorPlaceholder
                                            name={name}
                                            email={login}
                                            color={color}
                                            isShowInfo
                                        />

                                        {/* DropDownSelector для изменения прав */}
                                        {role_directory && role_directory !== 'owner' && (
                                            <DropDownSelector
                                                options_prop={options_prop}
                                                state={[options_prop.find(opt => opt.value === (userRoles[id] || role_directory))]}
                                                setState={(selectedOption) => {
                                                    if (selectedOption && selectedOption.value !== (userRoles[id] || role_directory)) {
                                                        handleRoleChange(id, selectedOption.value, userRoles[id] || role_directory);
                                                    }
                                                }}
                                                placeholder="Права"
                                                defaultValue={options_prop.find(opt => opt.value === (userRoles[id] || role_directory))}
                                            />
                                        )}

                                        {/* Отображение прав для разных ролей */}
                                        <div className="modal-add-permission__badges">
                                            <RoleBadje
                                                role={role_directory}
                                            />

                                            <RoleBadje
                                                role={role}
                                                isNote
                                            />
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                        :
                        <NoDataContent
                            description="Нет доступных сотрудников"
                        />
                    }
                </div>
            }
        />
    )
}

export { ModalAddPermission }